import {
  put,
  takeLatest,
  takeEvery,
  select,
  all,
  delay,
  call,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  paymentRequestSchema,
  paymentRequestListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/paymentRequests/actions';
import { PaymentRequestsActionTypes as types } from 'app/ducks/paymentRequests/types';

function* getPaymentRequestSaga(action, retry = 0): any {
  yield put(sagaActions.getPaymentRequestPending());
  const [error, response] = yield (yield yield TeammoApi(
    yield select(),
  )).organisationPaymentRequests.show(action.payload);

  if (!_.isEmpty(response)) {
    const normalizedResponse = normalize(response, paymentRequestSchema);
    yield put(sagaActions.getPaymentRequestSuccess(normalizedResponse));
    const pc = normalizedResponse.entities.paymentRequests[normalizedResponse.result];
    return pc;
  }
  yield put(
    handleError(
      error,
      sagaActions.getPaymentRequestFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  if (retry < 3) {
    yield delay(2500);
    yield call(getPaymentRequestSaga, action, retry + 1);
  }
  return null;
}

function* getAllPaymentRequestsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentRequestsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.paymentRequests.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield yield TeammoApi(
    yield select(),
  )).organisationPaymentRequests.list(paginationObject);
  if (response) {
    const normalizedResponse = normalize(response, paymentRequestListSchema);

    yield put(
      sagaActions.getAllPaymentRequestsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentRequestsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* getPaymentRequestSagaWatcher(): any {
  yield takeEvery(types.GET_PAYMENT_REQUEST_REQUESTED, getPaymentRequestSaga);
}

function* getAllPaymentRequestsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_PAYMENT_REQUESTS_REQUESTED,
    getAllPaymentRequestsSaga,
  );
}

export default function* root(): any {
  yield all([
    getPaymentRequestSagaWatcher(),
    getAllPaymentRequestsSagaWatcher(),
  ]);
}
